'use client';

import { FC, ReactNode, useCallback, useState } from 'react';

import { IconCircleCheck } from 'src/general/Icons/IconCircleCheck';
import { RecaptchaNotice } from 'src/general/components/RecaptchaNotice/RecaptchaNotice';
import { pushCarmaEvent } from 'src/general/helpers/carmaCritical';
import { FlexibleSection } from 'src/hygiene/sections/flexible-content/flexibleContent.type';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

import { NewsletterSignupForm } from './NewsletterSignupForm';

interface Props extends FlexibleSection {
  sectionData: {
    title: ReactNode;
  };
  microcopy: {
    privacy: ReactNode;
    success: ReactNode;
  };
}

export const NewsletterSignup: FC<Props> = ({ sectionData, microcopy }) => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleSuccess = useCallback((email: string) => {
    pushCarmaEvent({
      event: 'form_submission',
      metadata: {
        email: email,
        component_name: 'NewsletterSignup',
      },
    });
    pushToDataLayer({
      event: 'newsletter_signup',
      email: email,
    });
    setIsSuccess(true);
  }, []);

  return (
    <section className="c-se--article c-se--verticalSpacing">
      <h3 className="c-fs-h5 mb-6 font-extrabold smp:text-center">{sectionData.title}</h3>
      {isSuccess ? (
        <div className="flex flex-row items-center gap-2 smp:justify-center">
          <div className="text-for-suc-bas">
            <IconCircleCheck />
          </div>
          <p className="c-fs-body1 text-tex-def-tie1">{microcopy.success}</p>
        </div>
      ) : (
        <>
          <NewsletterSignupForm onSuccess={handleSuccess} />
          <footer className="mt-4 flex flex-col gap-2 smp:text-center">
            <div className="c-fs-caption text-tex-def-tie3">{microcopy.privacy}</div>
            <RecaptchaNotice />
          </footer>
        </>
      )}
    </section>
  );
};
